"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.URLSafeSerializer = void 0;
const isNil_1 = __importDefault(require("lodash/isNil"));
var URLSafeSerializer;
(function (URLSafeSerializer) {
    const ENC = {
        "+": "-",
        "/": "_",
        "=": ".",
    };
    const DEC = {
        "-": "+",
        _: "/",
        ".": "=",
    };
    function serialize(input) {
        if ((0, isNil_1.default)(input)) {
            return null;
        }
        const jsonString = JSON.stringify(input);
        const base64String = Buffer.from(jsonString, "utf8").toString("base64");
        const urlSafeBase64String = base64String.replace(/[+/=]/g, (c) => ENC[c]);
        return urlSafeBase64String;
    }
    URLSafeSerializer.serialize = serialize;
    function deserialize(input) {
        if ((0, isNil_1.default)(input)) {
            return null;
        }
        const base64String = input.replace(/[+/=]/g, (c) => DEC[c]);
        const jsonString = Buffer.from(base64String, "base64").toString("utf8");
        const deserializedState = JSON.parse(jsonString);
        return deserializedState;
    }
    URLSafeSerializer.deserialize = deserialize;
})(URLSafeSerializer || (exports.URLSafeSerializer = URLSafeSerializer = {}));
//# sourceMappingURL=url-safe-serializer.js.map